import styled from "styled-components";
import media from "constants/media";

import NextImage from "next/image";

export const DoubleCardStyled = styled.div`
    padding: 50px 0;

    color: var(--color-white);
    text-align: center;

    background: var(--color-darkNight);
`;

export const Content = styled.div`
    background-color: var(--color-darkNight);
    background-image: url("/images/doubler-x2.svg");
    background-repeat: no-repeat;
    background-position: 50% 110px;
    background-size: 300px auto;

    ${media.mdUp`
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-size: 370px auto;
        background-position: 280px 40px;
    `}
`;

export const TopContent = styled.div`
    ${media.mdUp`
        display: flex;
        align-items: center;
    `}
`;

export const DoublerImage = styled(NextImage)`
    width: 100%;
    max-width: 300px;

    ${media.mdUp`
        max-width: 525px;
        margin-left: -30px;
    `}
`;

export const BottomContent = styled.div`
    max-width: 300px;
    margin: 10px auto 0;

    ${media.mdUp`
        max-width: 580px;
        margin: 0 0 0 -150px;

        text-align: left;
    `}
`;

export const Title = styled.h2`
    margin: 0 auto;

    color: var(--color-white);
    font-weight: normal;
    font-size: 35px;
    font-family: var(--font-DINPro);
    line-height: 40px;
    text-align: center;

    span {
        font-family: var(--font-Agne);
    }

    ${media.mdUp`
        font-size: 64px;
        line-height: 70px;
        text-align: left;
    `}
`;

export const Description = styled.div`
    margin: 14px auto 25px;

    font-size: 18px;
    line-height: 25px;
    text-align: center;

    ${media.mdUp`
        font-size: 20px;
        line-height: 30px;
        text-align: left;
    `}
`;
